class Welfare {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
  const isSP = window.matchMedia("(max-width: 767px)").matches;

  const baseSettings = {
    loop: true,
    slidesPerView: 2,
    spaceBetween: -15,
    speed: 3000,
    centeredSlides: true,
    allowTouchMove: false,
    autoplay: isSP ? { delay: 0 } : false,
  };

  document.querySelectorAll('.js-welfare-swiper').forEach((el) => {
    console.log(el);
    
    new Swiper(el, baseSettings);
  });

  }
}
